import { Component } from "@angular/core";

@Component({
  selector: "ab-alerts-common",
  templateUrl: "./common.component.html",
})
export class AlertsCommonComponent {}
